<template>
	<div class="personSet_page">
		<div v-if="!update_success" class="pass_content">
			<input type="password" placeholder="当前密码 / Current Password">
			<input type="password" placeholder="新密码 / New Password">
			<input type="password" placeholder="重复密码 / Repeat Password">
			<button @click="updatePass">确认修改</button>
		</div>
		<div v-if="update_success" class="pass_content">
			<p>{{message}}</p>
			<button>返回</button>
		</div>	
	</div>
</template>

<script>
	export default {
	  name: 'changePass',
	  data () {
	    return {
			update_success:false,
			message:"修改成功"
	    }
	  },
	  methods:{
		  updatePass:function(){
			  this.update_success = true
		  }
	  }
	}
</script>

<style scoped="scoped">
	.pass_content{
		width:220px;
		height: 220px;
		margin-left:100px;
		padding:40px 40px;
		background-color: rgba(45,47,58,0.5);
		border-radius:20px;
	}
	.pass_content input{
		width: 200px;
		height: 25px;
		margin-top:20px;
		padding:5px 10px;
		font-size:12px;
		color: #E8E6E6;
		border-radius: 20px;
		border:0;
		user-select:none ;
		background-color: rgba(199,199,199);
	}
	.pass_content p{
		margin-top:20px;
		font-size:30px;
		color: #E8E6E6;
		text-align: center;
		margin-bottom:90px;
	}
	.pass_content button{
		width: 80px;
		padding:6px 10px;
		margin:30px 60px;
		font-size:12px;
		color: #fff;
		border:1px #fff solid;
		background: unset;
		border-radius:20px;
	}
	.pass_content button:hover{
		color: #000;
		background: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/personSet/changePass.vue